
































































































































































































































































import { Component } from 'vue-property-decorator';
import { LendingAccountModule } from '@/store/Accounts/LendingAccountModule';
import { AuthModule } from '@/store/Auth/AuthModule';
import SaascadaVue from '@/components/Shared/SaascadaVue';
import DetailsEditDialog from '@/components/Accounts/LendingAccounts/Details/DetailsEditDialog.vue';
import AccountState from '@/components/Accounts/Shared/AccountState.vue';
import AccountStateEditDialog from '@/components/Accounts/LendingAccounts/Details/AccountStateEditDialog.vue';
import ProductDetailsEditDialog from '@/components/Accounts/LendingAccounts/Details/ProductDetailsEditDialog.vue';
import ProductMigrationState from '@/components/Products/ProductMigrations/ProductMigrationState.vue';
import PermissionUtils from '@/lib/permissionUtils';
import PayeeType from '@/models/Accounts/Shared/Payees/PayeeType';

@Component({ name: 'Details', components: { DetailsEditDialog, AccountState, AccountStateEditDialog, ProductDetailsEditDialog, ProductMigrationState } })
export default class extends SaascadaVue {

    PermissionUtils = PermissionUtils;

    get account() {
        return LendingAccountModule.lendingAccount;
    }

    get iban() {
        // PaymentInterfaces can be undefined or an empty array
        if (this.account.paymentInterfaces?.length > 0) {
            return this.account.paymentInterfaces[0].iban;
        }
        return "";
    }

    get bic() {
        // PaymentInterfaces can be undefined or an empty array
        if (this.account.paymentInterfaces?.length > 0) {
            return this.account.paymentInterfaces[0].bic;
        }
        return "";
    }

    get sortCode() {
        // PaymentInterfaces can be undefined or an empty array
        if (this.account.paymentInterfaces?.length > 0) {
            return this.account.paymentInterfaces[0].sortCode;
        }
        return "";
    }

    get accountNumber() {
        // PaymentInterfaces can be undefined or an empty array
        if (this.account.paymentInterfaces?.length > 0) {
            return this.account.paymentInterfaces[0].accountNumber;
        }
        return "";
    }

    get productIssue() {
        return LendingAccountModule.lendingAccount.productIssueIdentifier;
    }

    get defaultWallet() {
        return LendingAccountModule.lendingAccount.wallets.find(wallet => wallet.default);
    }

    get includesUKPayeeType() {
        // Whether or not to show certain account details based on the payee type
        return this.availablePayeeTypes.includes(PayeeType.UK);
    }

    get availablePayeeTypes() {
        // TODO: This is currently taken from the go backend hardcoded field for AvailablePayeeTypes
        // But once this has been added to the main config the function can be swapped for just "institution.availablePayeeTypes"
        return AuthModule.me.institution.config.availablePayeeTypes;
    }

}
